import {
  getSummaryValue,
  processPredictionData,
  getTitle,
  buildDisplayText,
  formatModelValue,
  makeModelTables,
} from '../utils'
import { findEpiSuiteGroupById } from '@/components/combined-predict/models/epiSuite/epiSuiteColumnGroups'
import { isNil } from 'lodash-es'

const modelSummaryMapper = (item, meta) => {
  const selectedValue = getSummaryValue(item?.selectedValue ?? item?.predicted, getTitle(meta))

  const hlcName = buildDisplayText({
    mainText: getTitle(meta),
    secondaryText: meta?.unit,
  })

  const predictedValuesArray = item?.predicted?.model
    ?.map((pred) => formatModelValue(pred?.hlcAtm))
    .filter((value) => !isNil(value))

  const predictedMethods = item?.predicted?.model?.map((pred) => pred?.name).filter((name) => !isNil(name))

  const experimentalValuesArray = item?.experimental
    .map((expVal) => processPredictionData(expVal)?.value)
    .filter((value) => !isNil(value))

  const experimentalReferencesArray = item?.experimental
    .map((expVal) => processPredictionData(expVal)?.reference)
    .filter((value) => !isNil(value))

  const tableRow = [
    hlcName,
    predictedValuesArray,
    predictedMethods,
    experimentalValuesArray,
    experimentalReferencesArray,
  ]
  return {
    values: [selectedValue],
    tables: [
      {
        headers: ['', 'Estimated Value', 'Methods', 'Experimental Values', 'References'],
        rows: [tableRow],
        columnClasses: { 2: 'text-left' },
      },
    ],
  }
}

const modelDescriptorsMapper = (item) => ({
  tables: makeModelTables(item?.predicted?.model),
})

const hlc = (items) => {
  const item = items?.find((item) => item?.property === 'henrysLawConstant')
  const meta = findEpiSuiteGroupById('henrysLawConstant')

  return {
    title: getTitle(meta),
    description: meta?.description,
    helpPage: meta?.helpPage,
    summary: modelSummaryMapper(item, meta),
    modelDescriptors: modelDescriptorsMapper(item, meta),
    modelOutput: item?.predicted?.model?.output,
  }
}

export { hlc }
